import { FormatChange } from '../common';
import { useApiGet } from '../../hooks/useApiGet';

const MarketIndicators = () => {
    const { data: indices, error, loading } = useApiGet('/stocktracker/api/market-indices'); // test
    if (loading) return <div className="loading-box">Loading market indices...</div>;
    if (error) return <div className="error-box">Error: {error}</div>;
    if (!indices) return <div className="error-box">No market data available</div>;

    return (
        <div className="market-indicators-container">
            <div className="indicator-box">
                <h3>CAC 40</h3>
                <div className="indicator-value">
                    {indices?.cac40?.value || 'N/A'}
                </div>
                <div className="indicator-change">
                    <FormatChange change={indices?.cac40?.change} />
                </div>
            </div>

            <div className="indicator-box">
                <h3>CAC Mid & Small</h3>
                <div className="indicator-value">
                    {indices?.cac_mid_small?.value || 'N/A'}
                </div>
                <div className="indicator-change">
                    <FormatChange change={indices?.cac_mid_small?.change} />
                </div>
            </div>
        </div>
    );
};

export default MarketIndicators;